import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, withRouter } from "react-router-dom";

import { Container, Spinner } from "app/NativeComponents/common";
import { Page } from "app/NativeComponents/website/common";

import AppSideBar from "./AppSideBar";
import AppRoutes from "./AppRoutes";

import InfoBanner from "app/DealMachineCore/snippets/InfoBanner";

import {
  initApp,
  getUser,
  getStats,
  appRedirect,
  setDarkMode
} from "app/NativeActions";

class App extends Component {
  detectDarkMode() {
    const token = window.localStorage.getItem("dark_mode");
    this.props.setDarkMode(token);
  }

  /*check if the user is logged in*/
  detectUser() {
    const token = window.localStorage.getItem("token");
    if (token != null) {
      if (!this.props.user) {
        this.props.getUser({
          token,
          device: this.props.device,
          initialRedirect: this.props.initialRedirect
        });
      }
    } else {
      if (!this.props.user) {
        this.props.appRedirect({ redirect: "login" });
      }
    }
  }
  componentDidMount() {
    if (this.props.user && this.props.stats) {
      //onboarding
      this.props.appRedirect({
        redirect: "init",
        payload: {
          user: this.props.user,
          billing: this.props.stats.billing,
          dealfinder_page: this.props.user_dealfinder_page,
          is_partner: this.props.is_partner,
          accepted_affiliate_latest_terms: this.props
            .accepted_affiliate_latest_terms,
          type: "load"
        }
      });
    } else {
      this.detectUser();
    }
  }

  render() {
    if (this.props.token && this.props.user) {
      return (
        <Page
          metaTitle={
            this.props.user.firstname +
            " " +
            this.props.user.lastname +
            " - DealMachine for Real Estate Investing"
          }
        >
          <div className="dm-app-wrapper animated fadeIn deal-full-app">
            <AppSideBar />
            <div className="deal-app">
              <Route path={"/a"} component={AppRoutes} />
            </div>
          </div>
        </Page>
      );
    } else {
      return (
        <Page metaTitle={"DealMachine for Real Estate Investing"}>
          <div className="dm-app-wrapper animated fadeIn deal-full-app">
            <Container>
              <Spinner />
            </Container>
          </div>
        </Page>
      );
    }
  }
}

const mapStateToProps = ({ auth, native, drawer, team_link }) => {
  const { token, user, init } = auth;
  const { device, initialRedirect } = native;
  const { stats } = drawer;

  const { user_dealfinder_page } = team_link;

  return {
    token,
    user,
    init,
    device,
    initialRedirect,
    stats,
    user_dealfinder_page
  };
};

export default withRouter(
  connect(mapStateToProps, {
    initApp,
    getUser,
    getStats,
    appRedirect,
    setDarkMode
  })(App)
);
